/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmbedTokenInfoDto } from '../../models/embed-token-info-dto';

export interface EmbedsValidateGet$Json$Params {
  token?: string;
}

export function embedsValidateGet$Json(http: HttpClient, rootUrl: string, params?: EmbedsValidateGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbedTokenInfoDto>> {
  const rb = new RequestBuilder(rootUrl, embedsValidateGet$Json.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmbedTokenInfoDto>;
    })
  );
}

embedsValidateGet$Json.PATH = '/embeds/validate';
